module.exports = __webpack_public_path__ + "img/1.407f0f6c.jpg";